import { takeLatest, put } from 'redux-saga/effects'
import {
  GET_EXPORTED_XEROS,
  GET_EXPORTED_XEROS_SUCCESS,
} from 'Reducers/Xero/const'
import * as ERRORS from 'Reducers/Errors/const'
import { apiClient } from 'Module/API/Client'
import NProgress from 'nprogress'
import { callApi } from '../apiCall'

/**
 * Get exported xeros
 *
 * @param {Object} action
 */
function* getExportedXeros(action) {
  NProgress.start()
  const { callbacks = {} } = action
  try {
    const response = yield callApi(apiClient.getExportedXeros, callbacks)
    const xeros = yield response.json()

    yield put({
      type: GET_EXPORTED_XEROS_SUCCESS,
      payload: {
        xeros,
      },
    })
    callbacks.onSuccess && callbacks.onSuccess()
  } catch (ex) {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  NProgress.done()
}

/**
 * Watch get exported xeros
 */
export function* watchGetExportedXeros() {
  yield takeLatest(GET_EXPORTED_XEROS, getExportedXeros)
}



// WEBPACK FOOTER //
// ./src/Reducers/Xero/sagas.js